<template>
    <div id="contact-plugin" @mousedown="startDrag" :style="styleObject">
        <button @click="redirectToContact">
            <div class="button-content">
                <svg t="1725526990345" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
                    p-id="1508" width="30" height="30">
                    <path d="M516.1984 778.24c4.5056 0 9.1136-0.3072 13.7216-0.8192 44.2368-5.3248 81.8176-36.2496 95.6416-78.848 1.024-3.1744-0.512-6.5536-3.4816-7.9872-2.9696-1.4336-6.656-0.2048-8.3968 2.6624-0.2048 0.3072-17.7152 28.672-86.2208 37.888-10.24 1.3312-20.1728 2.048-29.696 2.048-47.9232 0-69.3248-18.1248-69.5296-18.2272a6.54336 6.54336 0 0 0-8.6016-0.1024c-2.4576 2.048-3.072 5.7344-1.3312 8.4992C439.296 757.248 476.7744 778.24 516.1984 778.24z m367.9232-424.0384c-0.6144 0-1.1264 0.1024-1.7408 0.1024C842.3424 180.736 689.152 51.2 505.4464 51.2 316.7232 51.2 159.9488 187.8016 125.2352 368.64c-33.792 6.0416-59.4944 35.7376-59.4944 71.68v143.6672c0 40.2432 32.256 72.9088 72.192 72.9088 22.528 0 42.3936-10.6496 55.6032-26.9312 31.9488 84.3776 96.8704 152.4736 179.0976 188.3136 0.2048-0.4096 1.7408-3.4816 3.584-5.8368 1.3312-1.6384 2.7648-3.072 3.9936-3.072 1.3312 0 2.4576 0.512 3.4816 1.2288-19.0464-14.1312-87.7568-87.04-102.6048-188.6208-6.5536-44.7488 26.9312-88.6784 65.9456-95.9488 62.6688-11.6736 124.928-24.9856 187.5968-36.352 39.8336-7.2704 67.072-29.0816 83.6608-65.4336 3.8912-8.4992 9.5232-25.7024 12.0832-50.4832 0.7168-3.6864 3.6864-6.5536 7.5776-6.5536 2.56 0 4.8128 1.3312 6.2464 3.1744l1.7408-1.024c24.6784 35.84 73.6256 115.2 80.6912 198.8608 8.0896 95.6416 3.584 161.1776-69.632 228.2496l-0.3072 0.3072c-1.024 1.1264-1.6384 2.56-1.6384 4.096 0 2.048 1.1264 3.7888 2.6624 4.9152 0.6144 0.2048 1.2288 0.6144 1.8432 0.8192 0.512 0.1024 0.9216 0.3072 1.4336 0.3072 0.512 0 0.9216-0.2048 1.3312-0.3072 1.024-0.512 2.048-1.2288 3.072-1.7408a335.27808 335.27808 0 0 0 157.184-190.8736A74.2912 74.2912 0 0 0 869.1712 645.12c-31.0272 141.0048-156.7744 229.2736-312.6272 242.688-9.3184-23.1424-32.3584-39.6288-59.2896-39.6288-35.2256 0-63.7952 27.9552-63.7952 62.3616S462.0288 972.8 497.2544 972.8c28.4672 0 52.224-18.2272 60.5184-43.3152 180.3264-14.6432 324.9152-121.856 355.1232-288.4608 26.624-11.1616 45.3632-37.2736 45.3632-67.8912v-145.408c0-40.5504-33.1776-73.5232-74.1376-73.5232z m-66.4576 41.7792c-47.0016-127.3856-168.96-218.4192-312.32-218.4192-142.848 0-264.2944 90.2144-311.7056 216.8832-2.3552-2.8672-5.12-5.3248-7.8848-7.8848 26.8288-154.3168 159.6416-271.5648 319.7952-271.5648 159.3344 0 291.7376 116.1216 319.488 269.312-2.8672 3.584-5.4272 7.4752-7.3728 11.6736zM372.5312 818.3808z" fill="#3384fe" p-id="1509"></path>
                </svg>
                <div class="text">联系客服</div> 
            </div>
        </button>
    </div>
</template>

<script>
export default {
    name: 'ContactButton',
    props: {
        type: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            isDragging: false,
            startX: 0,
            startY: 0,
            initialRight: 0,
            initialTop: 0,
            right: '25px',
            top: '500px',
            dragging: false,
            dragThreshold: 5,  // 拖拽的最小距离阈值
        };
    },
    methods: {
        startDrag(event) {
            this.isDragging = true;
            this.startX = event.clientX;
            this.startY = event.clientY;
            this.initialRight = parseInt(window.getComputedStyle(this.$el).right, 10);
            this.initialTop = parseInt(window.getComputedStyle(this.$el).top, 10);
            document.addEventListener('mousemove', this.onDrag);
            document.addEventListener('mouseup', this.stopDrag);
        },
        onDrag(event) {
            if (!this.isDragging) return;
            const deltaX = event.clientX - this.startX;
            const deltaY = event.clientY - this.startY;
            if (Math.abs(deltaX) > this.dragThreshold || Math.abs(deltaY) > this.dragThreshold) {
                this.dragging = true;
            }
            this.right = `${this.initialRight - deltaX}px`;
            this.top = `${this.initialTop + deltaY}px`;
        },
        stopDrag() {
            // 延迟设置 isDragging 为 false 以防止立即触发 click
            setTimeout(() => {
                this.isDragging = false;
            }, 0);
            document.removeEventListener('mousemove', this.onDrag);
            document.removeEventListener('mouseup', this.stopDrag);

            // 如果拖拽的距离不足以被认定为拖拽，则重置 dragging 标志
            if (!this.dragging) {
                this.dragging = false;
            }
        },
        redirectToContact(event) { 
            // 互联中台：1    互联溯源：2   速速云签：3   人如云：4   海鸥云：5     其余：客服中心
            if (!this.dragging) {
                if(this.type == 1 ){
                    window.open('https://y.hulianzaowu.com/news/txtlist_i127v.html', '_blank');
                } else if (this.type == 2){
                    window.open('https://y.hulianzaowu.com/news/txtlist_i126v.html', '_blank');
                } else if (this.type == 3){
                    window.open('https://y.hulianzaowu.com/news/txtlist_i125v.html', '_blank');
                } else if (this.type == 4){
                    window.open('https://y.hulianzaowu.com/news/txtlist_i124v.html', '_blank');
                } else if (this.type == 5){
                    window.open('https://y.hulianzaowu.com/news/txtlist_i123v.html', '_blank');
                }else{
                    window.open('https://y.hulianzaowu.com/news/newslist_j25v_p1v.html', '_blank');
                }
            }
            // 重置 dragging 标志
            this.dragging = false;
        }
    },
    computed: {
        styleObject() {
            return {
                position: 'fixed',
                right: this.right,
                top: this.top,
                zIndex: 99
            };
        }
    }
}
</script>

<style scoped>
#contact-plugin {
    cursor: move;
}

button {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: #FFFFFF;
    box-shadow: -2px 0px 13px 0px rgba(123,123,123,0.39);
    border: none;
    border-radius: 29px;
    padding: 20px 15px;
    cursor: pointer;
    font-size: 18px;
    color: #666666;
}

.button-content {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.text {
    writing-mode: vertical-rl;
    text-orientation: mixed;  
    padding-top: 4px;
} 

button svg {
    display: block;
    margin-bottom: 10px;
}
button {
    outline: none; /* 移除默认的 outline */
}

button:focus {
    outline: none; /* 移除聚焦状态下的 outline */
} 

button:hover svg path {
    /* Hover效果 */
}
</style>
